import busRoute from '../../../../../../assets/images/icons/busRoute.svg';
import ferry from '../../../../../../assets/images/icons/ferry.svg';
import subway from '../../../../../../assets/images/icons/subway.svg';
import train from '../../../../../../assets/images/icons/train.svg';
import walk from '../../../../../../assets/images/icons/walk.svg';
import floatToCurrency from '../../../../../../utils/floatToCurrency';
import OpacityAnimation from '../../../../../OpacityAnimation';
import { TrajetoSelecaoIda } from '../../../../types';
import { Container, Distance, DistanceTime, IconContainer, InstructionGroup, Instructions, Price, StepDescription, StepTitle, Time } from './styles';

interface IRoute {
  goingRoute: TrajetoSelecaoIda[];
}

export default function Route({ goingRoute }: IRoute) {
  const iconsMap: { [key: string]: string } = {
    Caminhada: walk,
    Trem: train,
    Ônibus: busRoute,
    Metrô: subway,
    Fretado: busRoute,
    Fluvial: ferry,
    Integração: busRoute,
  };

  return (
    <Container>
      <OpacityAnimation delay={0.15}>
        {goingRoute.map((routeData) => (
          <InstructionGroup key={Math.random() + routeData.distanciaTj}>
            <IconContainer>
              <img src={iconsMap[routeData.tipoTransp]} alt="" className='sameAsTheme' />
            </IconContainer>

            <Instructions>
              {routeData.letreiroTransporte === 'TRANSPORTE MANTIDO' ? (
                <StepTitle>
                  {routeData.letreiroTransporte}
                </StepTitle>
              ) : (
                <>
                  <StepTitle>
                    {routeData.tipoTransp === 'Caminhada'
                      ? 'Caminhe'
                      : routeData.descricaoCaminhada}
                  </StepTitle>

                  <StepDescription>
                    {routeData.tipoTransp === 'Caminhada'
                      ? (
                        <div>
                          {`De ${routeData.origemCaminhada} até ${routeData.destinoCaminhada}`}
                        </div>
                      )
                      : (
                        <>
                          <div className="transport">
                            {`${routeData.operadora} ${routeData.letreiroTransporte}`}
                          </div>
                          <div>
                            {`Em ${routeData.embarque} e viaje até ${routeData.desembarque}`}
                          </div>
                        </>
                      )}
                  </StepDescription>

                  <DistanceTime>
                    {routeData.tipoTransp !== 'Caminhada' && (
                      <Price>{floatToCurrency(routeData.valorBilTrecho)}</Price>
                    )}
                    <Distance>{`${routeData.distanciaTj}m`}</Distance>
                    <Time>{`${routeData.tempoTj}min`}</Time>
                  </DistanceTime>
                </>
              )}
            </Instructions>
          </InstructionGroup>
        ))}
      </OpacityAnimation>
    </Container>
  );
}
